import * as api from "~/api";
import * as jwt from "jsonwebtoken";
import { KEY_NAME } from "~/configs";
import { REBOOKING } from "~/utils/urlApi";

// export const getAllFollowUp = (baseUrl, data) => {
export const apiGetAllRebooking = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(`${baseUrl}${REBOOKING.GET_ALL}`, data);
};

// export const getClsSearchHistory = (baseUrl, data) => {
export const apiGetAllPatientRebooking = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.getHttpRequestParamsAsync(
    `${baseUrl}${REBOOKING.GET_ALL_PATIENT}`,
    data
  );
};

export const getRebookingByPatientId = (baseUrl, data) => {
  return api.postHttpRequestAsync(
    `${baseUrl}${REBOOKING.GET_REBOOKING_BY_PATIENT_ID}`,
    data
  );
};

export const getAllRebookingFromHistory = (baseUrl, data) => {
  return api.postHttpRequestAsync(
    `${baseUrl}${REBOOKING.GET_ALL_FROM_HISTORY}`,
    data
  );
};
